import './profile.common';

import languagesBox from './features/language-box';
import attachPopoutMenu from './helpers/attach-popout-menu';
import stickyElement from './features/sticky-element';

// Sticky profile navigation
stickyElement('.js-profile__nav');

// Show all languages
languagesBox('hover');

// Info box with individual details
attachPopoutMenu('.js-toggle-individuals', '.js-individuals-list', 'hover');
